import { render, staticRenderFns } from "./CRMQuickLog.vue?vue&type=template&id=422d2590&scoped=true&"
import script from "./CRMQuickLog.vue?vue&type=script&lang=js&"
export * from "./CRMQuickLog.vue?vue&type=script&lang=js&"
import style0 from "./CRMQuickLog.vue?vue&type=style&index=0&id=422d2590&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422d2590",
  null
  
)

export default component.exports